$(function () {
  app.dom = {
    header: $('#header'),
    main: $('#main')
  };

  app.response.callback = {
    desktop: function () { // 桌面端
      
    },
    padH: function () { // pad横版
      
    },
    padV: function () { // pad竖版
      mobileNav()
    },
    mobile: function () { // 手机端
      mobileNav()
      pageHeroSet()
    },
    all: function () { // 全端
      shareSNS();
      RegisteredText('.content-page-hero .c-page-hero-header-title');
      RegisteredText('.c-story-promo-title');
      RegisteredText('.content-card-grid .c-card-title');
      RegisteredText('.c-inspired-grid .c-inspired-title');
      // setSectionWidth();
      siteSwitcher();
      hideEleOfBlank();
      // setMainTop();
      // headerScroll();
      historyTimeLine();
      loadingElement();
      wechatModal();
      OSnow();
    }
  }
  app.pageInit();

  // 滚动条宽度
  app.loadFile({
   type: 'style',
   style: "body{ --scrollWidth: " + app.scroll.width + "px}"
  })

  function siteSwitcher() {
    $('.site-switcher-selected').on('click', function(e) {
      e.preventDefault();
      $(this).siblings('.site-switcher-dropdown').collapse('toggle');
    });
    $('.site-switcher-dropdown').on('show.bs.collapse', function() {
      $(this).siblings('.site-switcher-selected').addClass('expand');
    });
    $('.site-switcher-dropdown').on('hide.bs.collapse', function() {
      $(this).siblings('.site-switcher-selected').removeClass('expand');
    });
  }

  function hideEleOfBlank() {
    $(document).on('click', function() {
      var _con = $('.site-switcher-selector'); // 设置目标区域
      if(!_con.is(event.target) && _con.has(event.target).length === 0){
        $('.site-switcher-dropdown').collapse('hide');
      }
    });
  }

  function setMainTop() {
    var _headerHeight = app.dom.header.height()
    $('#main').css({'marginTop': _headerHeight})
  }

  function headerScroll() {
    var _offsetTop = $('.announcement').outerHeight() + $('.site-header-content-top').outerHeight();
    if (app.device.mobile) {
      _offsetTop = $('.announcement').outerHeight()
    }
    $('#main').position_callback({
      offsetTop: 0,
      topUp: function() {
        app.dom.header.css({'top': -Math.abs(_offsetTop)});
      },
      topDown: function() {
        app.dom.header.css({'top': 0});
      },
    });
  }

  function mobileNav() {
    $('.site-nav-toggle').on('click', function() {
      $('#mobileHeader').modal('show')
    });
    $('.site-header-mobile .site-nav-list .nav_link').on('click', function() {
      $(this).siblings('.nav-second-list').collapse('toggle');
    });
    $('#mobileHeader').on('shown.bs.modal', function() {
      $('html').addClass('.scroll-lock');
    });
    $('#mobileHeader').on('hide.bs.modal', function() {
      $('html').removeClass('.scroll-lock');
    });
  }

  function historyTimeLine() {
    $('.history-timeline-anchor').each(function(index,ele) {
      var _offseTop = $('#header .site-header-content-bottom').outerHeight(true);
      $(this).position_callback({
        offsetTop: _offseTop,
        topUp: function() {
          $('.history-timeline-tabbar-dropdown .tabbar-item').eq(index).addClass('active').siblings().removeClass('active');
        },
        topDown: function() {
          $('.history-timeline-tabbar-dropdown .tabbar-item').eq(index).addClass('active').siblings().removeClass('active');
        },
        bottomUp: function() {
          console.log('bottomUp')
        },
        bottomDown: function() {
          console.log('bottomDown')
        }
      })
    });
  }

  function loadingElement() {
    var loadingElement = '<div class="loadingio-spinner-spin-51v6kai3v7f"><div class="ldio-fr87ygr9u4p"><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div></div></div>'
    $('img[data-src]').each(function() {
      if ($(this).hasClass('lazyload-item')) {
        $(this).after(loadingElement);
      }
    });
  }

  function pageHeroSet() {
    if ($('.content-page-hero').length > 0) {
      if ($('.content-page-hero .c-page-hero-header-title').length > 0) {
        var title = $('.content-page-hero .c-page-hero-header-title').text()
        var element = '<section class="page-title"><div class="container"><h1 class="page-title_title">' + title + '</h1></div></section>'
        $('.site-main-container').prepend(element)
      }
      if ($('.content-page-hero .c-hero-link-list').length === 0 && $('.content-page-hero .c-hero-follow').length === 0) {
        $('.content-page-hero-content').hide();
      }
    }
  }

  function wechatModal() {
    $('.wechat-modal-btn').on('click', function(e) {
      e.preventDefault()
      $('#wechatModal').modal('show');
    })
  }

  function OSnow() {
    let agent = navigator.userAgent.toLowerCase();
    let isMac = /macintosh|mac os x/i.test(navigator.userAgent);
    if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0) {
      $('html').addClass('is-win')
    }
    if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
      $('html').addClass('is-win')
    }
    if (isMac) {
      $('html').addClass('is-mac')
    }
  }

  // 分享
  function shareSNS() {
    if ($("#share").length != 0) {
      socialShare('#share', {
        sites: ['wechat', 'weibo'],
        wechatQrcodeHelper: '',
        wechatQrcodeTitle: "",
        wechatQrcodeSize: 670,
      });
      $('.social-shared .icon-wechat').addClass('wechat-modal-btn')
      setTimeout(function() {
        var img_src = $('.social-shared .icon-wechat img').attr('src')
        $('.social-shared .icon-wechat')[0].dataset.image = img_src
      },200)
      
    }
  }

  // 注册商标上标
  // '.content-page-hero .c-page-hero-header-title'
  function RegisteredText(ele) {
    if ($(ele).length > 0) {
      $(ele).each(function() {
        var text = $(this).html()
        var chars = ''
        var newHtml = ''
        if (text && text.indexOf('®') > -1) {
          chars = text.split('®')
          chars.forEach(function(item, index, arr) {
            if (index < arr.length - 1) {
              newHtml+= item + '<sup>®</sup>'
            } else {
              newHtml+= item
            }
          })
          $(this).html(newHtml)
        }
      })
    }
  }

  // function setSectionWidth() {
  //   $('.content-section-block').each(function() {
  //     if($(this).find('.c-story-promo-grid').length > 0) {
  //       $(this).addClass('has-story')
  //     }
  //   })
  // }

});